import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=41cd8230&scoped=true"
import script from "./avatar.ts?vue&type=script&lang=ts&external"
export * from "./avatar.ts?vue&type=script&lang=ts&external"
import style0 from "./avatar.scss?vue&type=style&index=0&id=41cd8230&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd8230",
  null
  
)

export default component.exports